import { downloadData } from 'aws-amplify/storage';

export async function get_image(path) {
    try {
        //console.log(`get_image: Downloading image from path: ${path}`);
        const result = await downloadData({
            path: path,
            options: { bucket: 'static' }
        }).result;
        return result;
    } catch (error) {
    }
}
